import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import * as SecureLS from "secure-ls";
import Swal from "sweetalert2";
import { GlobalService } from "src/app/services/global.service";
import * as moment from "moment";
import { DatePipe } from "@angular/common";
import CryptoJS from "crypto-js";
import { APP_CONFIG, IAppConfig } from "src/app/app.config";
import { PlyrComponent } from "ngx-plyr";
import { CommonService } from "src/app/services/common.service";
import { StorageService } from "../../services/storage.service";

@Component({
  selector: "app-professor-video-search",
  templateUrl: "./professor-video-search.component.html",
  styleUrls: ["./professor-video-search.component.css"],
})
export class ProfessorVideoSearchComponent implements OnInit {
  @ViewChild(PlyrComponent) plyr: PlyrComponent;

  private ls = new SecureLS({ encodingType: "aes" });
  page: number = 1;
  page_size: number = 10;
  professorvideoList: any;
  professorvideo = [];
  professorvideo1 = [];
  prolength: any;
  department: Object;
  dept: any;
  classroom: Object;
  Table_pagination: boolean = false;
  class: any;
  subject: Object;
  subjectData: any;
  department_id: any;
  filter: any;
  subject_id: any;
  classroom_id: any;
  total_count: any;
  total: number;
  p: number;
  pagedItems: any[];
  filter_from: any;
  filter_end: any;
  prodessor: Object;
  prodessorData: any;
  professor_id: any;
  videodec: any;
  showvideo = false;
  viewvideo = false;
  videosrc: any;
  dataindex: any;
  filter_date: any;
  isLoginType: boolean;
  player: Plyr;
  searchForm: any;
  page_count: any[];
  srcv = "http://103.53.53.21:82/public/1/2/2020/3/3_low.mp4";
  professorid: any;
  profid: boolean = false;
  Proflist: object;
  departmentid: any;
  session_id: any;
  batchid: any;
  batch: Object;
  batchData: any;
  batch_id: any;
  pageshow: boolean;
  subjectlist: boolean;
  filtervalues: boolean;
  chiparray = [];
  sessionData: any;
  findedVal: any;
  minDate: Date;
  maxDate = new Date();
  date: any;
  filterPopupend: any;
  filterPopupfrom: any;
  sessionName: any;
  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    public router: Router,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    private datepipe: DatePipe,
    private route: ActivatedRoute,
    @Inject(APP_CONFIG) private config: IAppConfig,
    public commonService: CommonService
  ) { }
  roleId = this.storageService.getRole();
  async ngOnInit() {
    this.maxDate = new Date();
    this.minDate = new Date();
    this.subjectlist = false;
    this.searchForm = this.fb.group({
      id: [""],
      date: [""],
      depname: [""],
      subjectname: [""],
      proname: [""],
      classname: [""],
      batchname: [""],
      session: [""],
    });

    this.route.queryParams.subscribe((params) => {
      this.isLoginType = !!params["loginType"];
      this.globalService.loginType = params.loginType;
      if (params.loginType == "impersonate") {
        (this.roleId = this.ls.get("impersonate_role")),
          (this.professor_id = this.ls.get("impersonate_professor_id"));
      } else {
        this.roleId = this.storageService.getRole();
      }
    });
    this.getProfessor(true);
    this.getSession();
    this.getDepartment();
    this.getSubject();
    this.getclassroom();

    this.getBatch();
  }
  played(event: Plyr.PlyrEvent) { }
  get forms1() {
    return this.searchForm.controls;
  }

  async getPage(page: number) {
    this.page = page;
    await this.getprofessorvideoList();
    const res = await this.serverCall(this.professorvideo, page);
    this.total = this.total_count;
    this.p = page;
    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }

  async onDepartmentChange() {
    const deptVal = this.searchForm.get("depname")?.value;
    this.department_id = deptVal || null;
    this.professor_id = null;
    this.subject_id = null;
    this.searchForm.patchValue({
      proname: null,
      proffname: null,
      subjectname: null,
    });
    await this.getSubjectDropdown();
    await this.getProfessor();
  }

  async getSubjectDropdown() {
    const filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };

    const sessionVal = this.searchForm?.get("session")?.value;
    let sessionId = null;
    if (sessionVal && this.sessionData?.length) {
      const selectedSession = this.sessionData.find(s => s.session === sessionVal);
      sessionId = selectedSession?.id;
    } else if (this.findedVal?.id) {
      sessionId = this.findedVal.id;
    }

    if (sessionId) {
      filter.session_id = sessionId;
    }

    const departmentId =
      this.searchForm?.get("depname")?.value ||
      this.department_id ||
      this.departmentid;

    if (departmentId) {
      filter.department_id = departmentId;
    }

    const subject = await this.globalService.get(
      "subject/list/dropdown",
      filter,
      true
    );

    this.subjectData = subject["content"] || [];

    // Clear previously selected subject if not present in new list
    const currentSub = this.searchForm?.get("subjectname")?.value;
    if (currentSub && !this.subjectData.some((s: any) => s.id == currentSub)) {
      this.searchForm.patchValue({
        subjectname: null,
      });
      this.subject_id = null;
    }
  }

  async getProfessor(isInit: boolean = false) {
    this.spinner.show();
    const departmentId =
      this.searchForm.get("depname")?.value ||
      this.department_id ||
      this.departmentid;

    let filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    if (departmentId) {
      filter.department_id = departmentId;
    }

    this.prodessor = await this.globalService.get(
      "user/profeser/dropdown",
      filter,
      true
    );

    this.prodessorData = this.prodessor["content"] || [];

    // Check if selected professor exists in new department list
    if (this.professor_id) {
      const exists = this.prodessorData.find((x) => x.id == this.professor_id);
      if (!exists) {
        this.professor_id = null;
        this.searchForm.patchValue({
          proname: null,
          proffname: null,
        });
      }
    }

    // Default logged-in professor on initial load only
    if (isInit && !this.professor_id && this.roleId == 4) {
      let defaultProfId = this.ls.get("createdBy");
      this.route.queryParams.subscribe(params => {
        if (params.loginType == "impersonate") {
          defaultProfId = this.ls.get("impersonate_user_id");
        }
      });

      const profExists = this.prodessorData.find((x) => x.id == defaultProfId);
      if (profExists) {
        this.professorid = defaultProfId;
        this.professor_id = defaultProfId;
        this.profid = true;
        this.searchForm.patchValue({
          proname: defaultProfId,
        });

        if (profExists.department_id) {
          this.department_id = profExists.department_id;
          this.searchForm.patchValue({
            depname: profExists.department_id,
          });
        }

        const proffessor = this.prodessorData.filter(
          (x) => x.id == this.professor_id
        );
        if (proffessor && proffessor.length && proffessor[0]?.first_name) {
          const profChipExists = this.chiparray.some((chip) => chip.startsWith("Proff:"));
          if (!profChipExists) {
            this.chiparray.push(
              "Proff: " +
              proffessor[0].first_name +
              " " +
              proffessor[0].last_name
            );
          }
        }
      }
    }

    this.spinner.hide();
  }

  async getprofessorvideoList() {
    this.spinner.show();
    this.subjectlist = false;
    this.route.queryParams.subscribe((params) => {
      this.isLoginType = !!params["loginType"];
      this.globalService.loginType = params.loginType;
      if (params.loginType == "impersonate") {
        this.roleId = this.ls.get("impersonate_role");
        this.professorid = this.ls.get("impersonate_user_id");
      } else {
        this.roleId = this.storageService.getRole();
        this.professorid = this.ls.get("createdBy");
      }
    });

    var startUTCDate = moment(this.filter_from, "YYYY-MM-DD 00:00:00").utc();
    var endUTCDate = moment(this.filter_end, "YYYY-MM-DD 23:59:59").utc();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      page: this.page,
      page_size: this.page_size,
      // professor_id: this.profid === true ? this.professor_id : this.professorid,
      professor_id: this.professor_id || this.professorid,
      department_id: this.department_id,
      subject_id: this.subject_id,
      classroom_id: this.classroom_id,
      batch_id: this.batch_id,
      session_id: this.findedVal?.id
        ? this.findedVal?.id
        : this.storageService.getCurrentSession(this.sessionData)?.id,
      camera_start: this.filter_from,
      camera_end: this.filter_end,
    };
    this.professorvideoList = await this.globalService.get(
      "classVideoDetail/professor/search",

      filter,
    );
    if (this.professorvideoList["status"] === 200) {
      this.professorvideo = this.professorvideoList["content"]["rows"];
      this.total_count = this.professorvideoList["content"].count;
      this.page_count = [];
      let page_count = Math.ceil(this.total_count / this.page_size);
      if (page_count > 1) {
        this.Table_pagination = true;
      } else {
        this.Table_pagination = false;
      }
      this.spinner.hide();
    } else {
      if (this.professorvideoList["status"] == 422) {
        let msg = "";
        for (const [key, value] of Object.entries(
          this.professorvideoList["error"]["content"]
        )) {
          msg = `${key.toUpperCase()} ${value}`;
        }
        // Swal.fire({
        //   text: msg,
        //   icon: "warning",
        //   confirmButtonText: "OK",
        //   confirmButtonColor: "#808080",
        // });
      }
      this.spinner.hide();
    }

    (error) => {
      this.professorvideo = [];
      this.spinner.hide();
    };

    this.spinner.hide();
  }

  async getBatch() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.batch = await this.globalService.get(
      "batch/list/dropdown",
      filter,
      true
    );

    this.batchData = this.batch["content"];
    this.spinner.hide();
  }

  async getDepartment() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: "5",
    };
    this.department = await this.globalService.get(
      "department/list/dropdown",
      filter,
      false
    );

    this.dept = this.department["content"];
    this.spinner.hide();
  }

  async videoenc(id, hlsStatus) {
    const encrypt = (text) => {
      return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
    };
    const enryptText = hlsStatus == "0" ? "ZERO" : "ONE";
    let key = id;
    if (this.route.queryParams["value"].loginType == "impersonate") {
      window.open(
        `/video/play?key=${key}&loginType=impersonate&isHls=${encrypt(
          enryptText
        )}`,
        "_blank"
      );
    } else {
      window.open(
        `/video/play?key=${key}&isHls=${encrypt(enryptText)}`,
        "_blank"
      );
    }
  }

  getUtcToLocale(dateValue, timeValue, isDateRequested) {
    return this.globalService.getUtcToLocale(
      dateValue,
      timeValue,
      isDateRequested
    );
  }

  // async getSession() {
  //   this.chiparray = [];
  //   this.spinner.show();
  //   let filter = {
  //     user_id: this.ls.get("createdBy"),
  //     vendor_id: this.ls.get("vendor_id"),
  //     role_id: this.storageService.getRole(),
  //   };
  //   let session = await this.globalService.get(
  //     "session/dropdown",
  //     filter,
  //     true
  //   );
  //   this.sessionData = session["content"];
  //   const currentSession =
  //     this.storageService.getCurrentSession(this.sessionData);

  //   this.findedVal = currentSession;

  //   this.chiparray = [];
  //   // Session chip
  //   if (currentSession?.session) {
  //     this.chiparray.push(
  //       "Session : " + currentSession.session
  //     );
  //   }

  //   this.chiparray.push(
  //     "Date :" +
  //     " " +
  //     moment(new Date()).format("YYYY-MM-DD") +
  //     " - " +
  //     moment(new Date()).format("YYYY-MM-DD")
  //   );

  //   if (session["status"] == 200) {
  //     await this.getprofessorvideoList();
  //   }

  //   this.spinner.hide();
  // }
  async getSession() {
  this.spinner.show();
 
  let filter = {
    user_id: this.ls.get("createdBy"),
    vendor_id: this.ls.get("vendor_id"),
    role_id: this.storageService.getRole(),
  };
 
  let session = await this.globalService.get(
    "session/dropdown",
    filter,
    true
  );
 
  this.sessionData = session["content"];
 
  const currentSession =
    this.storageService.getCurrentSession(this.sessionData);
 
  this.findedVal = currentSession;
 
  // Set default values in filter popup
  const today = new Date();
  this.filter_from = moment(today).format("YYYY-MM-DD");
  this.filter_end = moment(today).format("YYYY-MM-DD");
 
  this.searchForm.patchValue({
    session: currentSession?.session,
    date: [today, today],
  });
 
  // Rebuild default chips
  this.chiparray = [];
 
  if (currentSession?.session) {
    this.chiparray.push("Session : " + currentSession.session);
  }
 
  this.chiparray.push(
    "Date : " + this.filter_from + " - " + this.filter_end
  );
 
  const professor = this.prodessorData?.find(
    x => x.id == this.professor_id
  );
 
  if (professor) {
    this.chiparray.push(
      "Proff: " + professor.first_name + " " + professor.last_name
    );
  }
 
  if (session["status"] == 200) {
    await this.getSubjectDropdown();
    await this.getprofessorvideoList();
  }
 
  this.spinner.hide();
}
 

  async onSessionChangeEvent(isInitLoad?) {
    this.forms1["date"].setValue(null);
    this.getFilterDate(null);
    let sessionVal = this.forms1["session"].value;
    if (sessionVal) {
      this.findedVal = this.sessionData?.find(
        (list) => list.session === sessionVal
      );
      if (this.findedVal?.start_date && this.findedVal?.end_date) {
        this.minDate.setDate(new Date(this.findedVal.start_date).getDate());
        this.minDate.setMonth(new Date(this.findedVal.start_date).getMonth());
        this.minDate.setFullYear(
          new Date(this.findedVal.start_date).getFullYear()
        );
        this.maxDate.setDate(new Date(this.findedVal.end_date).getDate());
        this.maxDate.setMonth(new Date(this.findedVal.end_date).getMonth());
        this.maxDate.setFullYear(new Date(this.findedVal.end_date).getFullYear());
      }
      await this.getSubjectDropdown();
      if (isInitLoad) {
        this.forms1["date"].setValue([new Date(), new Date()]);
        this.getFilterDate([new Date(), new Date()]);
      }
    } else {
      this.findedVal = null;
      this.forms1["date"].setValue(null);
      this.getFilterDate(null);
      await this.getSubjectDropdown();
    }
  }

  async getclassroom() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.classroom = await this.globalService.get(
      "classroom/list/dropdown",

      filter,
      true
    );

    this.class = this.classroom["content"];
    this.spinner.hide();
  }
  async getSubject() {
    await this.getSubjectDropdown();
  }
  async subjectList(batch_id, department_id, subject_id) {
    this.professorvideo = [];
    this.spinner.show();
    this.subjectlist = true;
    this.route.queryParams.subscribe((params) => {
      this.isLoginType = !!params["loginType"];
      this.globalService.loginType = params.loginType;
      if (params.loginType == "impersonate") {
        this.roleId = this.ls.get("impersonate_role");
        if (this.roleId == 4)
          this.professorid = this.ls.get("impersonate_user_id");
        else {
          this.departmentid = this.ls.get("impersonate_department_id");
          this.batchid = this.ls.get("impersonate_batch_id");
        }
      } else {
        this.roleId = this.storageService.getRole();
        if (this.roleId == 4) this.professorid = this.ls.get("createdBy");
        else {
          this.departmentid = department_id;
          this.batchid = batch_id;
        }
      }
    });

    if (this.roleId === 4) {

      let filter = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        role_id: this.storageService.getRole(),
        page: this.page,
        page_size: this.page_size,
        subject_id: subject_id,
        professor_id:
          this.profid === true ? this.professor_id : this.professorid,
        resolution_type: "low",
        session_id: this.findedVal?.id
          ? this.findedVal?.id
          : this.storageService.getCurrentSession(this.sessionData)?.id,
      };
      this.professorvideoList = await this.globalService.get(
        "classVideoDetail/professor/search",
        filter
      );

      this.professorvideo = this.professorvideoList["content"]["rows"];
      if (this.professorvideoList["status"] === 200) {
        this.showvideo = true;
      }
      this.prolength = this.professorvideoList["content"].count;

      this.professorvideo1 = [];
      this.professorvideo.map((item) => {
        this.professorvideo1.push(item);
      });
    }

    this.spinner.hide();
  }

  openScrollableContent(longContent) {
    this.findedVal = null;
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
      this.forms1["session"].setValue(
        this.storageService.getCurrentSession(this.sessionData)?.session
      );
      this.onSessionChangeEvent(true);
    }
  }

  Filter(department_id, subject_id, classroom_id, batch_id, professor_id) {
    this.filtervalues = true;
    this.chiparray = [];
    if (this.searchForm.controls["session"]?.value) {
      this.chiparray.push(
        "Session : " + this.searchForm.controls["session"]?.value
      );
    }
    if (this.filter != undefined && this.filter != "") {
      this.chiparray.push(
        "Date :" + " " + this.filter_from + " - " + this.filter_end
      );
    }

    if (
      this.prodessorData.length &&
      this.professor_id != undefined &&
      this.professor_id != ""
    ) {
      var proffessor = this.prodessorData.filter(
        (x) => x.id == this.professor_id
      );
      this.chiparray.push(
        "Proff:" +
        " " +
        proffessor[0]?.first_name +
        " " +
        proffessor[0]?.last_name
      );
    }

    if (this.department_id != undefined && this.department_id != "") {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
    }

    if (this.subject_id != undefined && this.subject_id != "") {
      var subject = this.subjectData.filter((x) => x.id == this.subject_id);
      this.chiparray.push("Subject:" + " " + subject[0].name);
    }

    if (this.batch_id != undefined && this.batch_id != "") {
      var Batch = this.batchData.filter((x) => x.id == this.batch_id);
      this.chiparray.push("Batch:" + " " + Batch[0].batch);
    }

    if (this.classroom_id != undefined && this.classroom_id != "") {
      var classroom = this.class.filter((x) => x.id == this.classroom_id);
      this.chiparray.push("Class:" + " " + classroom[0].name);
    }
    this.profid = true;
    this.batch_id = batch_id;
    this.professor_id = professor_id;
    this.department_id = department_id;
    this.subject_id = subject_id;
    this.classroom_id = classroom_id;
    this.page = 1;
    this.getprofessorvideoList();
  }

  getFilterDate(filter_date) {
    if (filter_date) {
      this.filter = filter_date;
      this.filter_from = moment(this.filter[0]).format("YYYY-MM-DD");
      this.filter_end = moment(this.filter[1]).format("YYYY-MM-DD");
      var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      var diffDays =
        Math.floor(
          new Date(this.filter_from).getTime() -
          new Date(this.filter_end).getTime()
        ) / oneDay; // hours*minutes*seconds*milliseconds
      var diffDays =
        Math.floor(
          new Date(this.filter_from).getTime() -
          new Date(this.filter_end).getTime()
        ) / oneDay;
      if (-diffDays > 180) {
        Swal.fire({
          text: "Please select dates within 180 days",

          icon: "warning",

          confirmButtonText: "OK",

          confirmButtonColor: "#808080",
        });
        this.searchForm.controls["date"].setValue("");
      }
    } else {
      this.filter_from = "";
      this.filter_end = "";
    }
  }

  // res() {
  //   this.chiparray = [];
  //   this.findedVal = null;
  //   this.filtervalues = false;
  //   this.department_id = null;
  //   this.subject_id = null;
  //   this.classroom_id = null;
  //   this.filter_from = null;
  //   this.filter_end = null;
  //   this.professor_id = null;
  //   this.session_id = null;
  //   this.batch_id = null;
  //   this.filter_date = null;
  //   this.searchForm.reset();
  //   this.page = 1;
  //   this.showvideo = false;
  //   this.viewvideo = false;
  //   this.getprofessorvideoList();
  // }

  async res() {
    this.findedVal = null;
    this.filtervalues = false;

    this.department_id = null;
    this.subject_id = null;
    this.classroom_id = null;
    this.batch_id = null;
    this.session_id = null;
    this.filter_date = null;

    this.searchForm.reset();

    // Default Professor
    if (this.globalService.loginType === "impersonate") {
      this.professorid = this.ls.get("impersonate_user_id");
    } else {
      this.professorid = this.ls.get("createdBy");
    }

    this.professor_id = null;
    this.profid = true;

    // Reload default professor and subject options for all departments
    await this.getProfessor(true);
    await this.getSubjectDropdown();

    // Default Session
    const currentSession =
      this.storageService.getCurrentSession(this.sessionData);

    this.findedVal = currentSession;

    // Default Date (Today)
    const today = new Date();
    this.filter_from = moment(today).format("YYYY-MM-DD");
    this.filter_end = moment(today).format("YYYY-MM-DD");

    // Restore filter values
    this.searchForm.patchValue({
      proname: this.professorid,
      depname: this.department_id,
      session: currentSession?.session,
      date: [today, today],
    });

    // Recreate filter chips
    this.chiparray = [];

    if (currentSession?.session) {
      this.chiparray.push("Session : " + currentSession.session);
    }

    this.chiparray.push(
      "Date : " + this.filter_from + " - " + this.filter_end
    );

    const professor = (this.prodessorData || []).find(
      (x) => x.id == this.professor_id
    );

    if (professor) {
      this.chiparray.push(
        "Proff: " +
        professor.first_name +
        " " +
        professor.last_name
      );
    }

    if (this.department_id && this.dept?.length) {
      const dept = this.dept.find((x) => x.id == this.department_id);
      if (dept) {
        this.chiparray.push("Dept: " + dept.name);
      }
    }

    this.page = 1;
    this.showvideo = false;
    this.viewvideo = false;

    this.getprofessorvideoList();
  }


  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getprofessorvideoList();
  }
  getProfessorName(professor) {
    return `${professor.first_name} `;
  }
}
function getDepartment() {
  throw new Error("Function not implemented.");
}
